import React, { useRef, useState, useEffect } from 'react';
import clsx from 'clsx';
import usePost from 'sdk/hooks/usePost';
import { useParams, useNavigate, Link } from 'react-router-dom'
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import Page from 'modules/app/components/Page';
import useUpdatePost from 'sdk/hooks/useUpdatePost';
import useDeletePost from 'sdk/hooks/useDeletePost';
import MessageModal from 'components/shared/modals/MessageModal';
import Field from 'components/shared/Field';
import { Textarea } from 'components/shared/Input';
import useIsAuth from 'sdk/hooks/useIsAuth';
import Button from 'components/shared/Button';
import OtherVideos from './OtherVideos';
import styles from './Post.module.scss';

// let interval: NodeJS.Timeout | undefined

function Post() {
  const params = useParams()
  const navigate = useNavigate()
  const id: string = params?.id || ''
  const { data: post } = usePost(id)
  const { data: { user: userData } } = useIsAuth()
  const userId = userData?.id || 0
  const [description, setDescription] = useState<string>('')
  const [showSuccessUpdate, setShowSuccessUpdate] = useState<boolean>(false)
  const [showSuccessDelete, setShowSuccessDelete] = useState<boolean>(false)
  const [showEdit, setShowEdit] = useState<boolean>(false)
  // const [videoProgress, setVideoProgress] = useState(0)

  const updatePostMutation = useUpdatePost({
    id, description,
  })

  const deletePostMutation = useDeletePost(id)

  useEffect(() => {
    if (updatePostMutation.isSuccess) {
      setShowSuccessUpdate(true)
      setShowEdit(false)
    }
  }, [updatePostMutation.isSuccess])

  useEffect(() => {
    if (deletePostMutation.isSuccess) {
      setShowSuccessDelete(true)
    }
  }, [deletePostMutation.isSuccess])

  useEffect(() => {
    setDescription(post?.description || '')
  }, [post?.description, showEdit])

  const videoRef = useRef<HTMLVideoElement>(null)
  const video = videoRef?.current

  // useEffect(() => () => {
  //   if (interval) clearInterval(interval)
  // }, [])

  const startVideo = () => {
    if (video) {
      video.play()
      // if (interval) clearInterval(interval)
      // setVideoProgress(getProgress())
      // interval = setInterval(() => setVideoProgress(getProgress()), 1000)
    }
  }

  const stopVideo = () => {
    if (video) {
      video.pause()
      // setVideoProgress(getProgress())
      // if (interval) clearInterval(interval)
    }
  }

  useEffect(() => {
    const videoEl = videoRef.current;
    return () => {
      if (videoEl) {
        videoEl.pause()
      }
    }
  }, [])

  if (!post) {
    return null
  }

  return (
    <div className={styles.container}>
      <div
        className={styles.video}
        onClick={() => {
          const isVideoPlaying = Boolean(
            Number(video?.currentTime) > 0
            && !video?.paused
            && !video?.ended
            && Number(video?.readyState) > 2,
          );
          if (isVideoPlaying) {
            stopVideo()
          } else {
            const videos = document.getElementsByTagName('video')
            for (let i = 0; i < videos.length; i += 1) {
              videos[i].pause()
            }
            startVideo()
          }
        }}
      >
        <Link to={`/feed/${post?.feed_data?.['global_flat:global']?.id}`}>
          <video
            src={post?.video_link}
            poster={post?.bg_cover || ''}
            ref={videoRef}
            autoPlay={false}
            preload="auto"
          />
        </Link>
      </div>
      {showEdit ? (
        <div className={styles.containerRight}>
          <div className={styles.headerRowEdit}>
            <h1 onClick={() => setShowEdit(false)}>
              <IconArrowRight />
              Edit post
            </h1>
          </div>

          <Field
            title="Description"
            info={(
              <span>
                Only up to
                {' '}
                <em>5 hashtags</em>
                {' '}
                allowed
              </span>
            )}
            infoRight={`${description.length}/2000 characters`}
          >
            <Textarea
              value={description}
              onChange={setDescription}
              rows={3}
              maxLength={2000}
              maxHashtag={5}
              withHighlight
              width="507px"
            />
          </Field>

          <Button
            className={styles.publishBtn}
            onClick={() => updatePostMutation.mutate()}
            disabled={updatePostMutation.isLoading}
          >
            Save
          </Button>
        </div>
      ) : (
        // Блок редактирования Видео, в списке видео на странице пользователя
        <div className={styles.containerRight}>
          <div className={styles.headerRow}>
            <h1 onClick={() => navigate('/profile')}>
              <IconArrowRight />
              Post
            </h1>
            <div className={styles.category}>
              {post?.category?.name}
            </div>
          </div>

          <div className={clsx(styles.containerRightScroll)}>
            <div className={styles.description}>
              {post?.description}
            </div>

            {(userId === post?.creator_user_id) ? (
              <div className={styles.btns}>
                <Button
                  className={styles.btn}
                  onClick={() => deletePostMutation.mutate()}
                  disabled={deletePostMutation.isLoading}
                  wide
                  secondary
                >
                  Delete
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => setShowEdit(true)}
                  wide
                >
                  Edit
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => navigate(`/feed/${post?.feed_data?.['global_flat:global']?.id}`)}
                  wide
                >
                  View
                </Button>
              </div>
            ) : null}

            <OtherVideos
              userId={post?.creator_user_id}
              exclude={post?.id}
            />
          </div>
        </div>
      )}

      {showSuccessUpdate ? (
        <MessageModal
          title="Success"
          status="success"
          onClick={() => setShowSuccessUpdate(false)}
          message="The post has been successfully updated!"
        />
      ) : null}
      {showSuccessDelete ? (
        <MessageModal
          title="Success"
          status="success"
          onClick={() => navigate('/profile')}
          message="The post has been successfully deleted!"
        />
      ) : null}
    </div>
  )
}

function PostPage() {
  return (
    <Page activeLink="/community">
      <Post />
    </Page>
  )
}

export default PostPage
